var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/buffer/~/isarray/index.js
// module id = 177
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/buffer/~/isarray/index.js